// extracted by mini-css-extract-plugin
module.exports = {"image-element-container":"external-image_image-element-container__8iGmL","image-preview":"external-image_image-preview__1MkH1","is-disabled":"external-image_is-disabled__nwjze"};